import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const SensorChartsSkeleton = () => {
  return [...Array(4)].map(() => (
    <div key={uuidv4()} className={style.skeletonWrapper}>
      <SkeletonBlock className={style.skeletonText} />
    </div>
  ));
};

export default SensorChartsSkeleton;
